import React from "react";
import { jqueryProcess } from "../externals/common";
import Message from "./Message";
import InterViews from "./Interviews";
import Videos from "./Videos";
import Numbers from "./Numbers";
import Works from "./Works";
import Flow from "./Flow";
import Benefits from "./Benefits";
import Footer from "./Footer";
import Education from "./Education";
import Environment from "./Environment";
import Recruitments from "./Recruitments";
import Cta from "./cta";
import scrollReveal from "scrollreveal";
import EmployeeInterview from "../Interview";
import EmployeeRecruit from "../Recruit";
import {
	timingFunctionCollapse,
	timingFunctionExpand,
	animateImgKeyframe1,
	animateImgKeyframe2,
	animateImgOptions,
	isMobile,
} from "../animations";

class IndexPage extends React.PureComponent {
	render() {
		const { sr, toInterview, toRecruit } = this.props;

		return (
			<div style={this.props.style} id="contents">
				<header className="l-header home-header">
					<div className="header-bg" />
					<div className="header-wrap">
						<div className="header-logo">
							<a
								className="_logo"
								href="https://www.lyzon.co.jp/"
								target="_blank"
								rel="noopener noreferrer"
							>
								<svg
									className="svgIcon"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 104.05 27.9"
								>
									<title>株式会社LYZON</title>
									<polygon points="20.71 11.96 6.9 19.93 13.8 23.91 27.61 15.94 20.71 11.96"></polygon>
									<polygon points="0 0 0 23.91 6.9 27.9 6.9 3.99 0 0"></polygon>
									<path d="M51.59,16.18v5.75H48.41V16.25L42.86,7.5h3.72L50,13.3l3.5-5.8h3.61Z"></path>
									<path d="M58.68,21.93V19.52l7.93-9.23H58.92V7.5H70.7V9.91l-7.94,9.24H70.7v2.78Z"></path>
									<path d="M80.71,22.18a7.4,7.4,0,0,1-7.65-7.42v0a7.67,7.67,0,0,1,15.34,0v0A7.46,7.46,0,0,1,80.71,22.18Zm4.37-7.46a4.38,4.38,0,0,0-4.37-4.54,4.32,4.32,0,0,0-4.33,4.5v0a4.39,4.39,0,0,0,4.37,4.53,4.31,4.31,0,0,0,4.33-4.49Z"></path>
									<polygon points="36 19.05 36 7.5 32.83 9.34 32.83 21.93 43.2 21.93 43.2 19.05 36 19.05"></polygon>
									<polygon points="100.92 9.31 100.92 16.39 94.15 7.5 91.22 7.5 91.22 21.93 94.36 21.93 94.36 12.76 101.35 21.93 104.05 21.93 104.05 7.5 100.92 9.31"></polygon>
								</svg>
							</a>
							<h1>株式会社LYZON　新卒／中途採用サイト</h1>
						</div>
						<div className="header-toggle">
							<div>
								<span />
								<span />
								<span />
							</div>
						</div>
						<nav className="header-nav-pc">
							<ul>
								<li>
									<a
										className="header-nav-link"
										href="#recruitments"
									>
										募集職種
									</a>
								</li>
								<li>
									<a
										className="header-nav-link"
										href="#interviews"
									>
										社員インタビュー
									</a>
								</li>
								<li>
									<a
										className="header-nav-link"
										href="#education"
									>
										職場環境
									</a>
								</li>
								<li>
									<a
										className="header-nav-link"
										href="#numbers"
									>
										数字で見る
									</a>
								</li>
								<li className="entry entry-new">
									<span>
										新卒採用
										<br />
										ENTRY
									</span>
									<ul className="downmenu">
										<li>
											<a
												href="https://job.mynavi.jp/27/pc/search/corp92309/outline.html"
												target="_blank"
												rel="noopener noreferrer"
											>
												<picture>
													<source
														srcSet="images/common/mainavi.webp"
														type="image/webp"
													/>
													<img
														src="images/common/mainavi.png"
														alt="マイナビ"
													/>
												</picture>
											</a>
										</li>
										{/* <li>
											<a
												href="https://job.rikunabi.com/2026/company/r620230017/"
												target="_blank"
												rel="noopener noreferrer"
											>
												<picture>
													<source
														srcSet="images/common/rikunavi.webp"
														type="image/webp"
													/>
													<img
														src="images/common/rikunavi.png"
														alt="リクナビ2026"
													/>
												</picture>
											</a>
										</li> */}
									</ul>
								</li>
								<li className="entry entry-mid">
									<a
										className="header-nav-link"
										target="_blank"
										href="https://www.lyzon.co.jp/recruit-form"
										rel="noopener noreferrer"
									>
										中途採用
										<br />
										ENTRY
									</a>
								</li>
							</ul>
						</nav>
						<nav className="header-nav-sp">
							<ul>
								<li>
									<a
										className="header-nav-link"
										href="#interviews"
									>
										社員インタビュー
									</a>
								</li>
								<li>
									<a
										className="header-nav-link"
										href="#numbers"
									>
										数字で見る
									</a>
								</li>
								<li>
									<a
										className="header-nav-link"
										href="#benefits"
									>
										職場の環境
									</a>
								</li>
								<li>
									<a
										className="header-nav-link"
										href="#recruitments"
									>
										募集職種
									</a>
								</li>
							</ul>
							<p className="text">新卒採用にご応募の方はこちら</p>
							<ul className="entry">
								<li className="entry-new">
									<a
										href="https://job.mynavi.jp/27/pc/search/corp92309/outline.html"
										target="_blank"
										rel="noopener noreferrer"
									>
										<picture>
											<source
												srcSet="images/common/mainavi.webp"
												type="image/webp"
											/>
											<img
												src="images/common/mainavi.png"
												alt="マイナビ"
											/>
										</picture>
									</a>
								</li>
								{/* <li className="entry-new">
									<a
										href="https://job.rikunabi.com/2026/company/r620230017/"
										target="_blank"
										rel="noopener noreferrer"
									>
										<picture>
											<source
												srcSet="images/common/rikunavi.webp"
												type="image/webp"
											/>
											<img
												src="images/common/rikunavi.png"
												alt="リクナビ2026"
											/>
										</picture>
									</a>
								</li> */}
							</ul>
							<p className="text">中途採用にご応募の方はこちら</p>
							<ul className="entry">
								<li className="entry-mid">
									<a
										className="header-nav-link"
										target="_blank"
										href="https://www.lyzon.co.jp/recruit-form"
										rel="noopener noreferrer"
									>
										ENTRY
									</a>
								</li>
							</ul>
						</nav>
					</div>
				</header>
				<main className="l-main theme-single">
					<article className="l-article">
						<section id="mainvisual">
							<div className="visual_text">
								<div className="text">
									さらなる挑戦を、
									<br />
									経験に。
								</div>
							</div>
							<div className="visual_image">
								<div className="visual_image_first">
									<picture>
										<source
											media="(min-width: 576px)"
											srcSet="images/mainvisual/1.webp"
											type="image/webp"
										/>
										<img
											src="images/mainvisual/1-sp.webp"
											alt=""
										/>
									</picture>
									<picture>
										<source
											media="(min-width: 576px)"
											srcSet="images/mainvisual/2.webp"
											type="image/webp"
										/>
										<img
											src="images/mainvisual/2-sp.webp"
											alt=""
										/>
									</picture>
									<picture>
										<source
											media="(min-width: 576px)"
											srcSet="images/mainvisual/3.webp"
											type="image/webp"
										/>
										<img
											src="images/mainvisual/3-sp.webp"
											alt=""
										/>
									</picture>
								</div>
								<div className="visual_image_second">
									<picture>
										<source
											media="(min-width: 576px)"
											srcSet="images/mainvisual/1.webp"
											type="image/webp"
										/>
										<img
											src="images/mainvisual/1-sp.webp"
											alt=""
										/>
									</picture>
									<picture>
										<source
											media="(min-width: 576px)"
											srcSet="images/mainvisual/2.webp"
											type="image/webp"
										/>
										<img
											src="images/mainvisual/2-sp.webp"
											alt=""
										/>
									</picture>
									<picture>
										<source
											media="(min-width: 576px)"
											srcSet="images/mainvisual/3.webp"
											type="image/webp"
										/>
										<img
											src="images/mainvisual/3-sp.webp"
											alt=""
										/>
									</picture>
								</div>
								<div className="visual_image_third">
									<picture>
										<source
											media="(min-width: 576px)"
											srcSet="images/mainvisual/1.webp"
											type="image/webp"
										/>
										<img
											src="images/mainvisual/1-sp.webp"
											alt=""
										/>
									</picture>
									<picture>
										<source
											media="(min-width: 576px)"
											srcSet="images/mainvisual/2.webp"
											type="image/webp"
										/>
										<img
											src="images/mainvisual/2-sp.webp"
											alt=""
										/>
									</picture>
									<picture>
										<source
											media="(min-width: 576px)"
											srcSet="images/mainvisual/3.webp"
											type="image/webp"
										/>
										<img
											src="images/mainvisual/3-sp.webp"
											alt=""
										/>
									</picture>
								</div>
							</div>
							<div className="visual_copy" />
							<div className="visual_scroll">
								<a className="scroll_btn" href="#message">
									<p className="scroll_txt">SCROLL</p>
								</a>
							</div>
						</section>
						<Message />
						<Recruitments toRecruit={toRecruit} />
						<InterViews toInterview={toInterview} />
						<Videos />
						<Education />
						<Environment />
						<Benefits />
						<Works />
						<Flow />
						<Numbers sr={sr} />
						<Cta />
					</article>
				</main>
				<Footer />
				<div className="topscroll">
					<a href="#mainvisual">
						<svg
							className="svgIcon"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 50 50"
						>
							<path d="M48,2V48H2V2H48m2-2H0V50H50V0Z"></path>
							<path d="M36.76,24.22l-10-6.54v20H23.2V17.62l-10,6.6V20.38l11.7-8.1,11.82,8.1Z"></path>
						</svg>
					</a>
				</div>
			</div>
		);
	}
}

export default class Home extends React.PureComponent {
	state = {
		showRecruit: false,
		showInterview: false,
		interviewData: null,
		recruitData: null,
		showTopPage: false,
	};

	clientRect = {
		left: 0,
		top: 0,
		width: 0,
	};

	dataId;

	constructor() {
		super();
		this.messageRef = React.createRef();
		this.sr = scrollReveal({
			duration: 1000,
			distance: "100px",
			easing: "cubic-bezier(0.000, 0.490, 0.580, 1.000)",
			scale: 0,
		});
		this.toInterview = this.toInterview.bind(this);
		this.toRecruit = this.toRecruit.bind(this);
		this.backToHomeFromInterview = this.backToHomeFromInterview.bind(this);
	}

	animateTitle = (elQuery) => {
		this.sr.reveal(elQuery, {
			distance: "50px",
			origin: "bottom",
			delay: 300,
		});
	};

	keepBodyStay = () => {
		if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
			let bodys = document.querySelector("#contents");
			bodys.style.display = "none";
		}
	};

	releaseBody = (el) => {
		if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
			let bodys = document.querySelector("#contents");
			bodys.style.display = "";
			el.scrollIntoView();
		}
	};

	// hideLoadingView = () => {
	//   let loadingEl = document.querySelector('#loading-container')
	//   let visualText = document.querySelector('#mainvisual .visual_text')
	//   setTimeout(() =>  visualText.style.display = 'block', 0)
	//   setTimeout(() =>  loadingEl.style.display = 'none', 1000)
	// }

	componentDidMount() {
		jqueryProcess();
		this.sr.reveal(
			document.querySelector("#message > .section_title"),
			{
				origin: "right",
			},
			100,
		);
		this.sr.reveal(
			document.querySelector("#message > .section_contents"),
			{
				delay: 200,
				origin: "bottom",
			},
			100,
		);
		this.animateTitle("#interviews > .section_title");
		this.sr.reveal(
			"#interviews > .section_contents li",
			{
				origin: "bottom",
			},
			200,
		);
		this.animateTitle("#video > .section_title");
		this.sr.reveal(
			"#video .video_list > div",
			{
				origin: "bottom",
			},
			400,
		);
		this.animateTitle("#numbers > .section_title");

		this.animateTitle("#works > .section_title");
		this.sr.reveal(
			"#works .works_list > div",
			{
				origin: "bottom",
			},
			400,
		);
		this.sr.reveal("#flow", {
			origin: "bottom",
		});
		this.animateTitle("#flow > .section_title");
		this.sr.reveal(".flow_first", {
			distance: "100px",
			origin: "left",
			delay: 600,
		});
		this.sr.reveal(".flow_second", {
			distance: "100px",
			origin: "right",
			delay: 900,
		});

		this.animateTitle("#benefits > .section_title");
		this.sr.reveal(
			"#benefits .section_contents > .benefits_item",
			{
				origin: "bottom",
			},
			300,
		);

		this.sr.reveal("#education > .section_left", {
			origin: "left",
			delay: 100,
		});
		this.sr.reveal("#education > .section_right", {
			origin: "right",
			delay: 100,
		});

		this.sr.reveal("#environment > .section_left", {
			origin: "left",
			delay: 100,
		});
		this.sr.reveal("#environment > .section_right", {
			origin: "right",
			delay: 100,
		});

		this.animateTitle("#recruitments > .section_title");
		this.sr.reveal(
			"#recruitments .job_list > .job_item",
			{
				origin: "bottom",
			},
			300,
		);

		// setTimeout(this.hideLoadingView, 3000)
		setTimeout(() => {
			this.setState({
				showTopPage: true,
			});
		}, 0);
	}

	toInterview = (evt) => {
		this.hideHeader();

		let el = evt.currentTarget.querySelector("img");
		let visualEl = el.parentElement;

		// don't animate photos if accessed via mobile
		if (!isMobile()) visualEl.style.visibility = "hidden";

		this.dataId = visualEl.parentElement.getAttribute("data-id");
		let src = el.getAttribute("src");
		let elRect = el.getBoundingClientRect();
		let imgTransitionContainer = document.querySelector("#fake-img");
		let imgTransition = imgTransitionContainer.firstChild;
		imgTransition.setAttribute("src", src);
		imgTransitionContainer.style.left = elRect.left + "px";
		imgTransitionContainer.style.top =
			document.documentElement.scrollTop + elRect.top + "px";
		elRect = el.getBoundingClientRect();

		let animateImg = () => {
			imgTransitionContainer.style.visibility = "visible";
			elRect = el.getBoundingClientRect();
			let interviewImg = document.querySelector(".interview-img");
			interviewImg.style.visibility = "hidden";
			let interviewImgImg = document.querySelector(".interview-img img");
			interviewImgImg.setAttribute("src", src);

			let lastRect = interviewImg.getBoundingClientRect();
			// store the img rect value from interview screen, to be used in reverse animation
			const { left, top, width, height } = lastRect;
			this.clientRect = {
				left: left, //- window.screen.width + 667, // magic number
				top: top - 5000, //-> use this for slide from below
				width,
				height,
			};
			imgTransitionContainer.animate(
				[
					{
						transform: animateImgKeyframe2,
					},
					{
						transform: animateImgKeyframe1(elRect, this.clientRect),
					},
				],
				{ ...animateImgOptions, delay: 100 },
			);

			setTimeout(() => {
				interviewImg.style.visibility = "visible";
				imgTransitionContainer.style.visibility = "hidden";
				visualEl.style.visibility = "visible";
			}, 1000);
		};

		setTimeout(() => {
			document.body.style.paddingRight = "17px";
			document.body.style.overflow = "hidden";
			this.setState(
				{
					showInterview: true,
					interviewData: this.dataId,
				},
				() => {
					// don't animate photos if accessed via mobile
					if (isMobile()) {
						let interviewImg =
							document.querySelector(".interview-img");
						interviewImg.style.visibility = "visible";
						let interviewImgImg =
							document.querySelector(".interview-img img");
						interviewImgImg.setAttribute("src", src);
						this.keepBodyStay();
					} else animateImg();
				},
			);
			let fixEle = document.querySelector(".interviews_lower");
			fixEle.style.paddingRight = "0px";
		}, 450);
	};

	hideHeader = () => {
		let header = document.querySelector(".home-header");
		let timeScale = 0.5;
		let flip = new window.FLIP({
			element: header,
			duration: 400 / timeScale,
			easing: timingFunctionCollapse,
		});
		flip.first();
		flip.last("last");
		flip.invert();
		flip.play();

		// also hide scroll to top button
		let topscroll = document.querySelector(".topscroll");
		topscroll.style.display = "none";
	};

	showHeader = () => {
		let header = document.querySelector(".home-header");
		let timeScale = 0.5;
		let flip = new window.FLIP({
			element: header,
			duration: 500 / timeScale,
			easing: timingFunctionExpand,
		});
		flip.first();
		flip.removeClass("last");
		flip.last();
		flip.invert();
		flip.play();

		// also show scroll to top button
		let topscroll = document.querySelector(".topscroll");
		topscroll.style.display = "block";
	};

	backToHomeFromInterview = () => {
		let el = document.querySelector("#interviews");
		this.releaseBody(el);
		setTimeout(() => {
			this.setState({
				showInterview: false,
			});
			document.body.style.overflow = "auto";
			document.body.style.paddingRight = 0;
			this.showHeader();
			el.style.visibility = "visible";
		}, 300);
	};

	backToHomeFromRecruit = () => {
		let el = document.querySelector("#recruitments");
		this.releaseBody(el);
		setTimeout(() => {
			this.setState({
				showRecruit: false,
			});
			document.body.style.overflow = "auto";
			document.body.style.paddingRight = 0;
			this.showHeader();
		}, 300);
	};

	toRecruit(evt) {
		let dataId = evt.target.getAttribute("data-id");
		this.hideHeader();

		setTimeout(() => {
			document.body.style.overflow = "hidden";
			document.body.style.paddingRight = "17px";
			this.keepBodyStay();
			this.setState({
				showRecruit: true,
				recruitData: dataId,
			});
		}, 400);
	}

	fixedStyle = {
		overflow: "auto",
		position: "fixed",
		top: 0,
		left: 0,
		bottom: 0,
		right: 0,
		zIndex: "99",
		WebkitOverflowScrolling: "touch",
	};

	render() {
		const {
			showRecruit,
			showInterview,
			interviewData,
			recruitData,
			showTopPage,
		} = this.state;

		return (
			<React.Fragment>
				<IndexPage
					messageRef={this.messageRef}
					sr={this.sr}
					toInterview={this.toInterview}
					toRecruit={this.toRecruit}
					style={{
						visibility: showTopPage ? "visible" : "hidden",
					}}
				/>
				{showInterview && (
					<EmployeeInterview
						ref={this.interviewRef}
						backToHome={this.backToHomeFromInterview}
						sr={this.sr}
						style={this.fixedStyle}
						interviewData={interviewData}
					/>
				)}
				{showRecruit && (
					<EmployeeRecruit
						backToHome={this.backToHomeFromRecruit}
						data={recruitData}
						style={this.fixedStyle}
					/>
				)}
				<div
					id="fake-img"
					style={{
						position: "absolute",
						width: "300px",
						height: "400px",
						top: "2790px",
						visibility: "hidden",
						zIndex: 999,
					}}
				>
					<img
						src=""
						style={{
							width: "100%",
							height: "100%",
							objectFit: "cover",
							objectPosition: "50% 0%",
						}}
						alt=""
					/>
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Home/index.js